import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { GetProductsRequestPost, Product, ProductsUtils } from '../../common';

@Component({
    selector: 'ca-product-tile',
    templateUrl: './product-tile.component.html',
    styleUrls: ['./product-tile.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProductTileComponent {
    readonly placeholderImageSrc = ProductsUtils.placeholderImageSrc;
    product = input.required<Product>();
    languageCode = input.required<GetProductsRequestPost['languageCode']>();
    countryCode = input.required<GetProductsRequestPost['countryCode']>();
    isSelected = input<boolean>(false);
    allowDifferentProductTypeSelection = input<boolean>(true);
    selectedProductType = input<Product['productType'] | undefined>();
    selectProduct = output<Product>();

    isDifferentProductType = computed(() => {
        if (this.allowDifferentProductTypeSelection()) return false;
        const selectedProductType = this.selectedProductType();
        if (!selectedProductType) return false;
        return this.product().productType !== selectedProductType;
    });
}
